/**
 * This function returns the new status for the box, from the status of the all items
 */

export const getBoxStatus = async (items) => {
    const allReturned = items.every(x => ["bought", "archived", "returned"].includes(x.status));

    return allReturned ? "returned" : "partially_returned";
}
